/*
 * @Author: crazycattle
 * @Date: 2021-10-29 14:12:10
 * @Description: content
 */
const CampusEnrollment = [
  // 校内名单管理
  {
    path: "/CampusEnrollment/campusrosterManage",
    name: "campusrosterManage",
    component: () => import("@/views/CampusEnrollment/campusrosterManage.vue"),
  },
  {
    path: "/CampusEnrollment/expandBeAllocated",
    name: "expandBeAllocated",
    component: () => import("@/views/CampusEnrollment/expandBeAllocated.vue"),
  },
  // 校内名单跟进
  {
    path: "/CampusEnrollment/campusrosterFollow",
    name: "campusrosterFollow",
    component: () => import("@/views/CampusEnrollment/campusrosterFollow.vue"),
  },
];

export default CampusEnrollment;
